<h2 mat-dialog-title>Neuanlage Kontrolltermin</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="form" class="dialog-form">
    <!-- Kunde -->
    <div class="form-group">
      <label class="form-label" for="kunde_id">Kunde *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="kunde_id"
        formControlName="kunde_id"
        required>
        <option value="">Kunde auswählen</option>
        <option *ngFor="let kunde of activeKunden" [value]="kunde.uuid">
          {{ kunde.suchbegriff }}
        </option>
      </select>
      <div *ngIf="form.get('kunde_id')?.hasError('required') && form.get('kunde_id')?.touched" class="text-red-500 text-sm mt-1">
        Kunde ist erforderlich
      </div>
    </div>

    <!-- Standort -->
    <div class="form-group">
      <label class="form-label" for="standort_id">Standort *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        [class.bg-gray-100]="!form.get('kunde_id')?.value"
        [class.cursor-not-allowed]="!form.get('kunde_id')?.value"
        id="standort_id"
        formControlName="standort_id"
        [disabled]="!form.get('kunde_id')?.value"
        required>
        <option value="">Standort auswählen</option>
        <option *ngFor="let standort of filteredStandorte" [value]="standort.id">
          {{ standort.name }}
        </option>
      </select>
      <div *ngIf="form.get('standort_id')?.hasError('required') && form.get('standort_id')?.touched" class="text-red-500 text-sm mt-1">
        Standort ist erforderlich
      </div>
      <div *ngIf="!form.get('kunde_id')?.value" class="text-gray-500 text-sm mt-1">
        Bitte zuerst einen Kunden auswählen
      </div>
    </div>

    <!-- Techniker -->
    <div class="form-group">
      <label class="form-label" for="techniker_id">Techniker *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="techniker_id"
        formControlName="techniker_id"
        required>
        <option value="">Techniker auswählen</option>
        <option *ngFor="let tech of techniker" [value]="tech.id">
          {{ getTechnikerName(tech) }}
        </option>
      </select>
      <div *ngIf="form.get('techniker_id')?.hasError('required') && form.get('techniker_id')?.touched" class="text-red-500 text-sm mt-1">
        Techniker ist erforderlich
      </div>
    </div>

    <!-- Durchführungsmonat -->
    <div class="form-group">
      <label class="form-label" for="durchfuehrungsmonat">Durchführungsmonat *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="durchfuehrungsmonat"
        formControlName="durchfuehrungsmonat"
        required>
        <option value="">Monat auswählen</option>
        <option *ngFor="let monthOption of availableMonths" [value]="monthOption.value">
          {{ monthOption.label }}
        </option>
      </select>
      <div *ngIf="form.get('durchfuehrungsmonat')?.hasError('required') && form.get('durchfuehrungsmonat')?.touched" class="text-red-500 text-sm mt-1">
        Durchführungsmonat ist erforderlich
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="onCancel()" class="mr-4">Abbrechen</button>
  <button mat-button (click)="onSubmit()" [disabled]="loading || !form.valid" color="primary" class="mr-4">
    <span *ngIf="loading">Wird erstellt...</span>
    <span *ngIf="!loading">Erstellen</span>
  </button>
</mat-dialog-actions>

